import React from 'react';
import { Search, RotateCcw } from 'lucide-react';
import { Select } from '@/components/ui/Select';
import type { TeamsListFilters as FilterType } from '../types/teamsList.types';

interface TeamsListFiltersProps {
  filters: FilterType;
  onFilterChange: (filters: FilterType) => void;
  onReset: () => void;
}

export function TeamsListFilters({ filters, onFilterChange, onReset }: TeamsListFiltersProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center gap-4 bg-white p-3 rounded-md border border-slate-100">
      {/* Search Bar - Flex 1 to take available space */}
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input
          type="text"
          placeholder="Tìm kiếm theo tên team, mã team, trưởng team..."
          className="w-full h-10 pl-10 pr-3 py-2 bg-slate-50 border border-slate-100 rounded-md sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500/20 focus:border-emerald-500/50 transition-all placeholder:text-slate-400"
          value={filters.search}
          onChange={(e) => onFilterChange({ ...filters, search: e.target.value })}
        />
      </div>

      {/* Filters Group - Horizontal on desktop, vertical on mobile */}
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 lg:w-auto w-full">
        <div className="w-full sm:w-[180px]">
          <Select
            value={filters.status}
            onValueChange={(val) => onFilterChange({ ...filters, status: val as any })}
            options={[
              { value: 'all', label: 'Tất cả trạng thái' },
              { value: 'active', label: 'Đang hoạt động' },
              { value: 'inactive', label: 'Tạm ngưng' },
              { value: 'on_leave', label: 'Đã giải thể' },
            ]}
          />
        </div>

        <div className="w-full sm:w-[200px]">
          <Select
            value={filters.department}
            onValueChange={(val) => onFilterChange({ ...filters, department: val })}
            options={[
              { value: 'all', label: 'Tất cả phòng ban' },
              { value: 'Thi công', label: 'Thi công' },
              { value: 'Bảo dưỡng', label: 'Bảo dưỡng' },
              { value: 'Kỹ thuật', label: 'Kỹ thuật' },
            ]}
          />
        </div>

        <button
          onClick={onReset}
          className="h-10 w-full sm:w-10 flex items-center justify-center rounded-md border border-slate-100 bg-slate-50 text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 transition-all group shrink-0"
          title="Làm mới bộ lọc"
        >
          <RotateCcw className="w-4 h-4 group-hover:rotate-[-45deg] transition-transform duration-300" />
        </button>
      </div>
    </div>
  );
}
